import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Layout from '@/components/layout/Layout';
import { CurrencyProvider } from '@/lib/currency';

import HomePage from '@/pages/HomePage';
import ToolsPage from '@/pages/ToolsPage';
import CategoriesPage from '@/pages/CategoriesPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import LegalPage from '@/pages/LegalPage';
import NotFoundPage from '@/pages/NotFoundPage';
import AdminPage from '@/pages/AdminPage';

import { PercentageCalculator, PercentageChangeCalculator, FractionsCalculator } from '@/pages/tools/mathTools';
import { AgeCalculator, DateCalculator, TimeCalculator } from '@/pages/tools/timeTools';
import { DiscountCalculator, SalaryCalculator, SavingsCalculator, InterestCalculator, LoanCalculator, TipCalculator } from '@/pages/tools/moneyTools';
import { UnitConverter, CurrencyConverter } from '@/pages/tools/conversionTools';
import { BMICalculator } from '@/pages/tools/healthTools';

function App() {
  return (
    <div className="App">
      <CurrencyProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/tools" element={<ToolsPage />} />
              <Route path="/categories" element={<CategoriesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy-policy" element={<LegalPage kind="privacy" />} />
              <Route path="/cookie-policy" element={<LegalPage kind="cookie" />} />
              <Route path="/terms" element={<LegalPage kind="terms" />} />
              <Route path="/advertising" element={<LegalPage kind="advertising" />} />
              <Route path="/admin" element={<AdminPage />} />

              <Route path="/tools/percentage-calculator" element={<PercentageCalculator />} />
              <Route path="/tools/percentage-change-calculator" element={<PercentageChangeCalculator />} />
              <Route path="/tools/fractions-calculator" element={<FractionsCalculator />} />
              <Route path="/tools/age-calculator" element={<AgeCalculator />} />
              <Route path="/tools/date-calculator" element={<DateCalculator />} />
              <Route path="/tools/time-calculator" element={<TimeCalculator />} />
  <Route path="/tools/time-duration-calculator" element={<TimeCalculator />} />
              <Route path="/tools/discount-calculator" element={<DiscountCalculator />} />
              <Route path="/tools/salary-calculator" element={<SalaryCalculator />} />
              <Route path="/tools/savings-calculator" element={<SavingsCalculator />} />
              <Route path="/tools/interest-calculator" element={<InterestCalculator />} />
              <Route path="/tools/loan-calculator" element={<LoanCalculator />} />
              <Route path="/tools/tip-calculator" element={<TipCalculator />} />
              <Route path="/tools/unit-converter" element={<UnitConverter />} />
              <Route path="/tools/currency-converter" element={<CurrencyConverter />} />
              <Route path="/tools/bmi-calculator" element={<BMICalculator />} />

              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </CurrencyProvider>
    </div>
  );
}

export default App;
